<template>
  <div class="supplement-types text-dark">
    <div class="supplement-types__header">
      <div class="supplement-types__header__left">
        <h2>Faste tillæg</h2>
        <ChangeSchoolYear :white-theme="true"></ChangeSchoolYear>
      </div>
      <div class="supplement-types__header__left">
        <button class="do-bttn do-bttn--submit" @click="setIsCreateModal(true)">Opret tillæg</button>
      </div>
    </div>
    <div class="supplement-types__header">
      <div class="supplement-types__header__left">
        <Tabs :tabs="[
          {id: '', title: 'Alle'},
          {id: '(Lønbrøk)', title: 'Lønbrøk'},
          {id: 'undervisningstillæg', title: 'UV-tillæg'},
          {id: 'opgaver', title: 'Opgaver'},
          ]"
              :selected="selectedTab"
              @select="selectedTab = $event">
        </Tabs>
        <button class="do-bttn" @click="asyncLoadXLSXAndDownloadSimple" :class="{'do-bttn--loading': isDownloading}">
          Download
          to excel
        </button>
      </div>
      <div class="supplement-types__header__left">
        <button class="do-bttn"
                v-if="selectedTab === '(Lønbrøk)'"
                @click="generateSalarySupplements('lønbrøk')">
          Hent lønbrøk
        </button>
        <button class="do-bttn"
                @click="generateSalarySupplements('undervisningstillæg')"
                v-if="selectedTab === 'undervisningstillæg'">
          Hent UV-timer over 750
        </button>
        <button class="do-bttn"
                @click="generateSalarySupplements('opgaver')"
                v-if="selectedTab === 'opgaver'">
          Hent opgaver med tillæg
        </button>
        <button class="do-bttn"
                @click="setIsShowTasksModal(true)"
                v-if="selectedTab === 'opgaver'">
          Tilføj tillægstyper til opgaver
        </button>
      </div>
    </div>
    <div>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <table class="do-table" v-else>
        <thead>
        <tr>
          <th>Navn</th>
          <th>Identitet</th>
          <th>Brutto årsnorm</th>
          <th class="width-period">Beregningsperiode</th>
          <th>Tillægstype</th>
          <th>Konto</th>
          <th>Enheder overtid</th>
          <th>Enheder i periode</th>
          <th>Antal udbetalinger</th>
          <th>Enh. pr måned</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="supplementsFiltered.length === 0">
          <td colspan="11">
            <i>Ingen oprettet i skoleåret</i>
          </td>
        </tr>
        <tr class="supplement-list-item" v-for="supplement in supplementsFiltered" :key="supplement.id"
            @click="setEditSupplement(supplement)">
          <td>{{ supplement.vUserName }}</td>
          <td></td>
          <td>{{ supplement.year_norm_hours }}</td>
          <td class="width-period">{{ formatPeriod(supplement.valid_period) }}</td>
          <td>{{ supplement.code }}</td>
          <td>{{ supplement.account || '—' }}</td>
          <td>—</td>
          <td>{{ formatDecimal(supplement.units) }}</td>
          <td>{{ supplement.installments }}</td>
          <td>{{ formatDecimal(supplement.units_per_installment) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <CreateSupplement
      v-if="isCreateModal"
      :isSubmitting="isSubmitting"
      :supplementTypes="supplementTypes"
      :schoolId="schoolId"
      :schoolYearId="schoolYearId"
      :schoolYear="schoolYear"
      :editSupplement="editSupplement"
      @save="createSupplement"
      @update="updateSupplement"
      @close="setIsCreateModal(false)"
      @delete="deleteSupplement"
    ></CreateSupplement>
    <TaskOverviewSettings
      v-if="isShowTasksModal"
      :isSupplements="true"
      :supplementTypes="supplementTypes"
      @close="setIsShowTasksModal(false)"
    ></TaskOverviewSettings>
  </div>
</template>

<script>
import docendo from '../../docendo'
import moment from 'moment'
import Loader from '../common/Loader.vue'
import CreateSupplement from './CreateSupplement.vue'
import ChangeSchoolYear from '../School/ChangeSchoolYear.vue'
import Tabs from '../common/Tabs.vue'
import TaskOverviewSettings from '../TaskOverviewSettings/TaskOverviewSettings.vue'

let XLSX = null
export default {
  components: {TaskOverviewSettings, Tabs, ChangeSchoolYear, CreateSupplement, Loader},
  props: {
    supplementTypes: {
      default: () => []
    },
    schoolId: {
      default: () => null
    },
    schoolYear: {
      default: () => null
    },
    schoolYearId: {
      default: () => null
    }
  },
  data () {
    return {
      isLoading: true,
      supplements: [],
      isCreateModal: false,
      isSubmitting: false,
      theEditSupplementType: null,
      selectedTab: '',
      isShowTasksModal: false,
      isDownloading: false,
      editSupplement: null
    }
  },
  computed: {
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    supplementsSorted () {
      return this.supplements
        .map(supplement => {
          const user = this.allUsersInHash[supplement.user_id]
          return {
            ...supplement,
            vUserName: user ? user.name : 'Ukendt bruger'
          }
        })
        .sort((a, b) => {
          const nameA = a.vUserName.toLowerCase()
          const nameB = b.vUserName.toLowerCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })
    },
    supplementsFiltered () {
      const uvTillaegCodes = [111122, 5652]
      if (this.selectedTab === '(Lønbrøk)') {
        return this.supplementsSorted.filter(supplement => String(supplement.code) === '(Lønbrøk)')
      }
      if (this.selectedTab === 'undervisningstillæg') {
        return this.supplementsSorted.filter(supplement => uvTillaegCodes.map(String).includes(String(supplement.code)))
      }
      if (this.selectedTab === 'opgaver') {
        return this.supplementsSorted.filter(supplement => String(supplement.code) !== '(Lønbrøk)' && !uvTillaegCodes.map(String).includes(String(supplement.code)))
      }
      return this.supplementsSorted
    }
  },
  watch: {
    schoolYearId (val) {
      this.readSupplements()
    }
  },
  methods: {
    deleteSupplement (supplementId) {
      this.isDeleting = true
      docendo.deleteSalarySupplement(this.schoolId, this.schoolYearId, supplementId, success => {
        this.setIsCreateModal(false)
        this.isDeleting = false
        this.readSupplements()
      }, failure => {
        console.log('failed')
      })
    },
    setEditSupplement (supplement) {
      this.editSupplement = supplement
      this.setIsCreateModal(true)
    },
    setIsShowTasksModal (bool) {
      this.isShowTasksModal = bool
      if (bool) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    formatPeriod (periodStr) {
      if (!periodStr || periodStr.indexOf('...') === -1) return ''
      const parts = periodStr.split('...')
      return moment(parts[0]).format('DD-MM-YYYY') + ' til ' + moment(parts[1]).format('DD-MM-YYYY')
    },
    formatDecimal (val) {
      const num = parseFloat(val)
      return isNaN(num) ? '—' : num.toFixed(4).replace('.', ',')
    },
    generateSalarySupplements (supplementType) {
      docendo.generateSalarySupplements(this.schoolId, this.schoolYearId, supplementType, success => {
        this.readSupplements()
        // this.supplements = success
      }, failure => {
        console.log(failure)
      })
    },
    setIsCreateModal (bool) {
      this.isCreateModal = bool
      if (!bool) {
        this.theEditSupplementType = null
        this.editSupplement = null
      }
    },
    readSupplements () {
      console.log('readSupplements')
      this.isLoading = true
      if (!this.schoolYearId || !this.schoolId) {
        return
      }
      docendo.listSalarySupplements(this.schoolId, this.schoolYearId, success => {
        this.supplements = success
        this.isLoading = false
      })
    },
    createSupplement (supplement) {
      this.isSubmitting = true

      const {
        userId,
        employmentId,
        yearNormHours,
        startDate,
        endDate,
        code,
        account,
        units,
        installments,
        unitsPerInstallment
      } = supplement

      docendo.createSalarySupplement(
        this.schoolId,
        this.schoolYearId,
        userId,
        employmentId,
        yearNormHours,
        startDate,
        endDate,
        code,
        account,
        units,
        installments,
        unitsPerInstallment,
        success => {
          console.log({success})
          this.readSupplements()
          this.isSubmitting = false
          this.setIsCreateModal(false)
        },
        failure => {
          console.log(failure)
          this.isSubmitting = false
        }
      )
    },
    updateSupplement (supplement) {
      this.isSubmitting = true

      const {
        id,
        userId,
        employmentId,
        yearNormHours,
        startDate,
        endDate,
        code,
        account,
        units,
        installments,
        unitsPerInstallment
      } = supplement

      docendo.updateSalarySupplement(
        this.schoolId,
        this.schoolYearId,
        id,
        userId,
        employmentId,
        yearNormHours,
        startDate,
        endDate,
        code,
        account,
        units,
        installments,
        unitsPerInstallment,
        success => {
          console.log({success})
          this.readSupplements()
          this.isSubmitting = false
          this.setIsCreateModal(false)
        },
        failure => {
          console.log(failure)
          this.isSubmitting = false
        }
      )
    },
    dataToExcelSimple () {
      return this.supplementsFiltered.map(supplement => {
        return {
          'name': supplement.vUserName || '',
          'identity': '', // Du har tom celle i din tabel - tilpas hvis du har data
          'year_norm': supplement.year_norm_hours || '',
          'period': this.formatPeriod(supplement.valid_period) || '',
          'supplement_type': supplement.code || '',
          'account': supplement.account || '—',
          'overtime_units': '—', // Tom ifølge din tabel - tilpas hvis du vil
          'units_in_period': this.formatDecimal(supplement.units) || '',
          'installments': supplement.installments || '',
          'units_per_month': this.formatDecimal(supplement.units_per_installment) || ''
        }
      })
    },
    asyncLoadXLSXAndDownloadSimple () {
      this.isDownloading = true
      if (window.XLSX && XLSX) {
        this.downloadSimple()
      } else {
        const cdnXLSX = document.createElement('script')
        cdnXLSX.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.mini.min.js')
        document.head.appendChild(cdnXLSX)
        let intervalTimer = setInterval(_ => {
          if (window.XLSX) {
            clearInterval(intervalTimer)
            XLSX = window.XLSX
            this.downloadSimple()
          }
        }, 500)
      }
    },
    downloadSimple () {
      const headers = {
        'name': 'Navn',
        'identity': 'Identitet',
        'year_norm': 'Brutto årsnorm',
        'period': 'Beregningsperiode',
        'supplement_type': 'Tillægstype',
        'account': 'Konto',
        'overtime_units': 'Enheder overtid',
        'units_in_period': 'Enheder i periode',
        'installments': 'Antal udbetalinger',
        'units_per_month': 'Enh. pr måned'
      }

      const rows = this.dataToExcelSimple()

      rows.unshift(headers)

      const sheet = XLSX.utils.json_to_sheet(rows, {skipHeader: true})
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, sheet, 'data')
      const timestamp = moment().format('YYYY-MM-DD_HH-mm')
      const filename = `tillaeg_eksport_${timestamp}.xlsx`
      XLSX.writeFile(wb, filename)

      this.isDownloading = false
    }
  },
  mounted () {
    this.readSupplements()
  }
}
</script>

<style scoped>

.supplement-types {
  padding: 1rem;
  max-width: 1440px;
}

.supplement-types__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.do-table tr:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table tr:hover .width-50__icon {
  opacity: 1;
}

.supplement-types__header__left {
  display: flex;
  align-items: center;
  gap: 1rem
}

.width-period {
  width: 185px;
}

.supplement-list-item:hover {
  cursor: pointer;
  background: aliceblue !important;
}
</style>



// WEBPACK FOOTER //
// SupplementsList.vue?ac3aa8be